<mat-card #card class="min-width-card flexible-card"
          [ngClass]="{ 'selected': currentControl && (currentControl.id == currentRouteHardwareId), 'heating': heatActive(), 'cooling': coolActive() }"
          [ngStyle]="getMinDimensions()"
          (click)="cardClicked($event)">
    <mat-card-header>
        <div mat-card-avatar>
            <dl-device-status-cell *ngIf="device || (currentControl && currentControl.controlSummaryViewModel)"
                                   fxLayoutAlign="center center" class="rotated-status-icon"
                                   [deviceStatusType]="getDeviceStatusType()"
                                   [deviceCategory]="getDeviceCategory()"
                                   [hideRecommendedActions]="true"
                                   [useAlternativeIcon]="true">
            </dl-device-status-cell>
        </div>

        <mat-card-title *ngIf="device && device.tag">
            <div>{{ device.tag }}</div>
        </mat-card-title>
        <mat-card-title *ngIf="!device && currentControl">{{ currentControl.text }}</mat-card-title>
        <mat-card-subtitle>{{getState()}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="full-height">
        <div #cardInfo class="full-height">
            <dl-card-display-info
                *ngIf="currentControl && currentControl.displayInfo && isReady"
                [displayInfo]="currentControl.displayInfo"
                [displayInfoForEdit]="displayInfoForEdit"
                [isEditMode]="isEditMode"
                [dashboardEditModel]="deviceInformationConverted"
                [form]="form"
                [heating]="heatActive()"
                [cooling]="coolActive()"
                [setDeviceInfo]="setDeviceInfo"
            >
            </dl-card-display-info>
            <loading-animation size="large"
                               *ngIf="!isReady || (device && device.model === undefined)"></loading-animation>
        </div>
    </mat-card-content>

    <mat-card-actions class="stick-to-bottom" *ngIf="isReady">

        <div *ngIf="isEditMode && isReady" class="filterButtonsDiv">
            <div *ngIf="isEditMode && isReady" class="filterButtons-wrapper-left">
                <button *ngIf="isEditMode && isReady" [disabled]="!(isEditMode && form.touched && form.valid)"
                        (click)="saveChangesEx()" mat-button
                        aria-label="Save">
                    <mat-icon>save</mat-icon>
                    <br>
                    SAVE
                </button>
                <button *ngIf="isEditMode && isReady" (click)="isEditMode = false" mat-button aria-label="Cancel">
                    <mat-icon>cancel</mat-icon>
                    <br>
                    CANCEL
                </button>
            </div>
            <div *ngIf="isEditMode && isReady && (currentControl?.commands?.controlSummaryTemplate?.isVisible || (currentControl?.commands?.commisionerModelOperations?.isVisible && deviceInformation?.$deviceHierarchy?.jobNumber != null))" class="filterButtons-wrapper-right">
                <button mat-icon-button
                        [matMenuTriggerFor]="userMenu" *ngIf="isEditMode && isReady && (currentControl?.commands?.controlSummaryTemplate?.isVisible || (currentControl?.commands?.commisionerModelOperations?.isVisible && deviceInformation?.$deviceHierarchy?.jobNumber != null))">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #userMenu="matMenu">

                    <button [disabled]="false" (click)="selectTemplate()" *ngIf="isEditMode && isReady && currentControl?.commands?.controlSummaryTemplate?.isVisible" mat-menu-item [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}">
                        <mat-icon>settings_ethernet</mat-icon>
                        <span>Apply Template</span>
                    </button>

                    <button [disabled]="false" (click)="makeTemplate()" *ngIf="isEditMode && isReady && currentControl?.commands?.controlSummaryTemplate?.isVisible" mat-menu-item [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}">
                        <mat-icon>code</mat-icon>
                        <span>Create Template</span>
                    </button>

                    <button [disabled]="false" (click)="onImportFromCAALFileClick()" *ngIf="currentControl?.commands?.commisionerModelOperations?.isVisible && isEditMode && isReady && deviceInformation?.$deviceHierarchy?.jobNumber != null" mat-menu-item [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}">
                        <mat-icon>import_export</mat-icon>
                        <span>Import From CAAL File</span>
                    </button>

                </mat-menu>
            </div>
        </div>

        <button *ngIf="shouldEditButtonBeVisible()" (click)="enableEditMode()"
                mat-button
                aria-label="Edit"
                title="Edit">
            <mat-icon>settings</mat-icon>
            <br>
            SETTINGS
        </button>
        <button mat-button
                *ngFor="let subroute of visibleSubroutesPart1()"
                [uiSref]="subroute.name"
                [uiParams]="{ locationId: locationId, areaId: areaId, modelName: section.modelName, hardwareItemId: currentControl ? currentControl.id : -1 }"
                [uiOptions]="{ reload: subroute.name }"
                [disabled]="!subroute.isEnabled(currentControl)"
                [title]="subroute.title"
                (click)="unfocusAll()">
            <mat-icon *ngIf="subroute.name.indexOf('schedul') > -1">event_note</mat-icon>
            <mat-icon *ngIf="subroute.name.indexOf('currentinfo') > -1">settings_suggest</mat-icon>
            <mat-icon *ngIf="subroute.name.indexOf('system') > -1">settings_applications</mat-icon>
            <mat-icon *ngIf="subroute.name.indexOf('audit') > -1">history</mat-icon>
            <br>
            {{ subroute.linkText | uppercase }}
        </button>

        <button mat-button *ngIf="showAnalyticsLink()"
                [uiSref]="analyticsLink.state"
                [uiParams]="analyticsLink.params"
                [uiOptions]="{ reload: analyticsLink.state}"
                [title]="'Go To Analytics'">
            <mat-icon>bar_chart</mat-icon>
            <br>
            ANALYTICS
        </button>
        <button mat-button *ngIf="showMonitoringLink()"
                [uiSref]="monitoringLink.state"
                [uiParams]="monitoringLink.params"
                [uiOptions]="{ reload: monitoringLink.state}"
                [title]="'Go To Monitoring'">
            <mat-icon>settings_input_antenna</mat-icon>
            <br>
            MONITORING
        </button>
        <button mat-button *ngIf="showControlsLink()"
                [uiSref]="controlsLink.state"
                [uiParams]="controlsLink.params"
                [uiOptions]="{ reload: controlsLink.state}"
                [title]="'Go To Controls'">
            <mat-icon>build</mat-icon>
            <br>
            CONTROLS
        </button>


        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More" *ngIf="isMenuVisible()">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button *ngIf="shouldEditButtonBeVisible(true)" (click)="enableEditMode()"
                    mat-button
                    aria-label="Edit"
                    title="Edit"
                    [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}">
                <mat-icon>settings</mat-icon>
                <br>
                SETTINGS
            </button>
            <button mat-button *ngFor="let subroute of visibleSubroutesPart2()" [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}"
                    [uiSref]="subroute.name"
                    [uiParams]="{ locationId: locationId, areaId: areaId, modelName: section.modelName, hardwareItemId: currentControl ? currentControl.id : -1 }"
                    [uiOptions]="{ reload: subroute.name }"
                    [disabled]="!subroute.isEnabled(currentControl)"
                    [title]="subroute.title">
                <mat-icon *ngIf="subroute.name.indexOf('schedul') > -1">event_note</mat-icon>
                <mat-icon *ngIf="subroute.name.indexOf('currentinfo') > -1">settings_suggest</mat-icon>
                <mat-icon *ngIf="subroute.name.indexOf('system') > -1">settings_applications</mat-icon>
                <mat-icon *ngIf="subroute.name.indexOf('audit') > -1">history</mat-icon>
                <br>
                {{ subroute.linkText | uppercase }}
            </button>

            <button mat-button *ngIf="showAnalyticsLink(true)" [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}"
                    [uiSref]="analyticsLink.state"
                    [uiParams]="analyticsLink.params"
                    [uiOptions]="{ reload: analyticsLink.state}"
                    [title]="'Go To Analytics'">
                <mat-icon>bar_chart</mat-icon>
                <br>
                ANALYTICS
            </button>
            <button mat-button *ngIf="showMonitoringLink(true)" [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}"
                    [uiSref]="monitoringLink.state"
                    [uiParams]="monitoringLink.params"
                    [uiOptions]="{ reload: monitoringLink.state}"
                    [title]="'Go To Monitoring'">
                <mat-icon>settings_input_antenna</mat-icon>
                <br>
                MONITORING
            </button>
            <button mat-button *ngIf="showControlsLink(true)" [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}"
                    [uiSref]="controlsLink.state"
                    [uiParams]="controlsLink.params"
                    [uiOptions]="{ reload: controlsLink.state}"
                    [title]="'Go To Controls'">
                <mat-icon>build</mat-icon>
                <br>
                CONTROLS
            </button>
            <button *ngIf="currentControl?.commands?.commisionerModelOperations?.isVisible && shouldExportToCAALFileButtonBeVisible()" (click)="onExportToCAALFileClick()"
                    mat-button
                    aria-label="CAALExport"
                    title="CAALExport"
                    [ngClass]="{'mat-menu-dark-theme': isDarkTheme()}">
                <mat-icon>import_export</mat-icon>
                <br>
                Export To CAAL File
            </button>
        </mat-menu>
    </mat-card-actions>
</mat-card>
